import * as THREE from 'three';

import planogramConfig from 'shared/config/PlanogramConfig';
import { SphereGeometry } from 'shared/geometries/SphereGeometry';

export class SphereTextureGeometry {
  geometry: SphereGeometry;

  private readonly x: number;

  private readonly width: number;

  private readonly y: number;

  private readonly height: number;

  constructor(params: { x: number; y: number; width: number; height: number }) {
    // eslint-disable-line max-statements
    this.x = params.x;
    this.y = params.y;
    this.width = params.width;
    this.height = params.height;
    this.geometry = this.generateGeometry();
  }

  generateGeometry() {
    const azimuthLength = SphereGeometry.calcAzimuthLengthRadians(
      this.width,
      planogramConfig.WIDTH / 2.0,
    );
    // If these numbers are too low, on narrow (portrait) enough screens, the edges of the display are "mirrored"
    // TODO: understand root cause and find a solution that doesn't have a performance cost
    const cols = Math.ceil((600 * azimuthLength) / Math.PI);
    const rows = Math.ceil((600 * this.height) / planogramConfig.HEIGHT);
    const startU = 1;
    const endU = 0;
    const startV = 0;
    const endV = 1;

    const geom = new SphereGeometry(
      planogramConfig.ALPHA,
      planogramConfig.SHELL_RADIUS,
      planogramConfig.EQUATOR_RADIUS,
      cols,
      rows,
      SphereGeometry.calcAzimuthStartRadians(this.x, this.width, planogramConfig.WIDTH / 2.0),
      azimuthLength,
      planogramConfig.HEIGHT * 2,
      this.y,
      this.height,
      true,
      new THREE.Vector2(startU, startV),
      new THREE.Vector2(endU, endV),
    );
    return geom;
  }
}
